/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["kxv-Deva",[["ए एम","पी एम"],u,["ए एम","पी एम"]],u,[["आ","साॅ","मा","पू","ला","सु","सा"],["आदि","साॅम्मा","मान्गा","पूदा","लाक्की","सुकुरु","सान्नि"],["आदि वारा","साॅम्वारा","मंगाड़ा","पुद्दारा","लाक्कि वारा","सुकुरु वारा","सान्नि वारा"],["आ","साॅ","मा","पू","ला","सु","सा"]],u,[["पु","मा","पा","हि","बे","जा","आ","स्रा","बाॅ","दा","दि","पा"],["पुसु","माहा","पागु","हिर्रे","बेसे","जाट्टा","आसाड़ी","स्राबाँ","बाॅदो","दासारा","दिवी","पान्डे"],["पुसु लेञ्जु","माहाका लेञ्जु","पागुणी लेञ्जु","हिरे लेञ्जु","बेसे लेञ्जु","जाटा लेञ्जु","आसाड़ी लेञ्जु","स्राबाँ लेञ्जु","बोदो लेञ्जु","दसारा लेञ्जु","दिवी लेञ्जु","पान्डे लेञ्जु"]],u,[["बिसि","ए-डि"],u,["बिफोर क्राइस्ट","अन्नो डोमिनी"]],0,[0,0],["d/M/yy","d MMM y","d MMMM y","EEEE, d MMMM y"],["h:mm a","h:mm:ss a","h:mm:ss a z","h:mm:ss a zzzz"],["{1}, {0}",u,"{1} आँ {0}",u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##,##0.###","#,##0%","¤#,##,##0.00","#E0"],"INR","₹","बारत ति टाकाँ",{"JPY":["JP¥","¥"],"USD":["US$","$"]},"ltr", plural];
